var exports = {
  "g4": "InviteModal.module__loadingContainer___MHF0ZE",
  "qy": "InviteModal.module__channelSubtitle___MHF0ZE",
  "HA": "InviteModal.module__channelName___MHF0ZE",
  "p": "InviteModal.module__channelIcon___MHF0ZE",
  "ak": "InviteModal.module__inviteButton___MHF0ZE",
  "UW": "InviteModal.module__warningContainer___MHF0ZE",
  "QW": "InviteModal.module__warningIcon___MHF0ZE",
  "i4": "InviteModal.module__warningText___MHF0ZE",
  "xr": "InviteModal.module__expirationText___MHF0ZE",
  "bv": "InviteModal.module__editLink___MHF0ZE",
  "Wm": "InviteModal.module__detailedView___MHF0ZE",
  "WT": "InviteModal.module__noChannelContent___MHF0ZE",
  "Q9": "InviteModal.module__noChannelIcon___MHF0ZE",
  "E_": "InviteModal.module__noChannelText___MHF0ZE",
};

module.exports = exports;
